import type { MasterVariant } from '../../types'

export type MasterVariantImageFields = Pick<MasterVariant, 'productImages'>

export const getMainImageUrl = (
  masterVariant: MasterVariantImageFields,
): string => masterVariant.productImages?.mainImage.medium.jpgUrl ?? ''
